import React, { memo, useCallback, useEffect } from "react";
import { Box, MainText } from "app/components/common";
import Animated, {
  interpolate,
  useAnimatedStyle,
  useSharedValue,
  withSequence,
  withSpring,
} from "react-native-reanimated";
import { Vibration } from "react-native";

interface Props {
  likedBy: any;
}

const LikeLabel = ({ likedBy }: Props) => {
  const animateScale = useCallback(() => {
    const timeoutId = setTimeout(() => {
      scale.value = withSequence(
        withSpring(3, {
          damping: 20,
          stiffness: 100,
          restSpeedThreshold: 0.5,
          restDisplacementThreshold: 0.02,
          velocity: 30,
        }),
        withSpring(1, {
          damping: 20,
          stiffness: 100,
          restSpeedThreshold: 0.5,
          restDisplacementThreshold: 0.01,
        }),
      );
    }, 5);
    return () => clearTimeout(timeoutId);
  }, [likedBy]);

  const scale = useSharedValue(1);

  const animatedStyle = useAnimatedStyle(() => {
    const translateY = interpolate(scale.value, [0.5, 1], [0, -2.5]);

    return {
      transform: [{ scale: scale.value }, { translateY: translateY }],
    };
  });

  useEffect(() => {
    if (likedBy.length > 0) {
      return animateScale();
    }
    Vibration.vibrate(50);
  }, [likedBy.length]);

  return (
    <Box
      style={{
        paddingHorizontal: 5,
        paddingVertical: 2,
      }}
      minWidth={25}
      position="absolute"
      backgroundColor="neutral.200"
      flexDirection="row"
      borderColor="neutral.white"
      borderWidth={1}
      borderRadius={15}
      bottom={-13}
      right={4}
      justifyContent="center"
      alignItems="center"
    >
      <Animated.Text style={[animatedStyle, { fontSize: 10, marginTop: 4 }]}>
        ❤️
      </Animated.Text>
      {likedBy.length > 1 && (
        <MainText marginLeft="xxs" fontSize={10}>
          {likedBy.length}
        </MainText>
      )}
    </Box>
  );
};

export default memo(LikeLabel, (prevProps, nextProps) => {
  return prevProps.likedBy.length === nextProps.likedBy.length;
});
